import React, { useEffect, useState, useContext } from "react";
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
  Outlet,
  useParams,
} from "react-router-dom";
// import FinancialDepartment3 from "../components/admin-panel/financial-department/Index";
import FinancialDepartment3 from "pages/FinancialManagement";
import { SupplierContextProvider } from "context/SupplierContext";
import { UserContextProvider } from "context/UserContext";
import { CustomerClubContextProvider } from "context/CustomerClubContext";
import HomePage from "pages/Home/HomePage";
import CustomerManagment from "pages/CustomerManagment";
import ShopPage from "pages/ShopPage";
import BussinessPage from "pages/BussinessPage";
import MarketerPage from "pages/MarketerPage";
import ProductPage from "pages/ProductPage";
import CartListPage from "pages/CartListPage";
import Layout from "components/layout/Layout";
import Supplier from "pages/Supplier";
import Landing from "pages/Landing";
import WithPageTitle from "utils/WithPageTitle";
import SpecialBaskets from "../components/landing/SpecialBaskets.tsx";
import AuthenticationContext from "Authentication/AuthenticationContext.ts";
import FinancialDepartment from "../components/admin-panel/Transaction/Transactions.jsx";
import AdminPanel from "pages/AdminPanel.tsx";
import ProfilePage from "pages/ProfilePage";
import CustomerPanel from "pages/CustomerPanel.jsx";
import ParentListLines from "pages/ListLines.js";
import ClubPage from "pages/ClubPage";
import WalletList from "../pages/WalletList";
import UploadPage from "components/admin-panel/upload-page/UploadPage.tsx";
import ProfileBase from "../components/profile/ProfileBase";
import { ACCESS_LEVEL, ROUTES } from "../constant/constant.js";
import Loader from "utils/Loader";
import PermissionButton from "components/permission-button/PermissionButton.tsx";
import FinancialDepartment2 from "pages/FinancialDepartment";
import Transactions from "pages/Transactions";
import SubLinePage from "pages/SubLine";
import OrdersSuperAdmin from "pages/OrdersSuperAdmin";
import SuperAdminHome from "pages/SuperAdminHome";
export default function Router() {
  const [itemss, setItemss] = useState([]);
  const [updater, setUpdater] = useState(false);

  return (
    <>
      <SupplierContextProvider>
        <UserContextProvider>
          <CustomerClubContextProvider>
            <WithPageTitle />
            <Routes>
              {/*  صفحات سوپر ادمین   */}
              <Route path="super-admin-panel" element={<ProtectedRoute />}>
                {/*  صفحه سوپر ادمین   */}
                {/* صفحه محصول    */}
                <Route
                  path=""
                  element={
                    <Layout>
                      <SuperAdminHome />
                    </Layout>
                  }
                />
                <Route
                  index
                  path="dashboard"
                  element={
                    <Layout>
                      <HomePage
                        itemss={itemss}
                        setItemss={setItemss}
                        setUpdater={setUpdater}
                        updater={updater}
                      />
                    </Layout>
                  }
                />
                {/* صفحه محصول    */}
                <Route
                  path="kala"
                  element={
                    <Layout>
                      <ProductPage />
                    </Layout>
                  }
                />
                {/* صفحه لیست سبد خرید    */}
                <Route
                  path="cart-list"
                  element={
                    <Layout>
                      <CartListPage />
                    </Layout>
                  }
                />
                {/* صفحه بازاریاب    */}
                <Route
                  path="marketer"
                  element={
                    <Layout>
                      <MarketerPage />
                    </Layout>
                  }
                />
                {/*صفحه مدیریت کاربران */}
                <Route
                  path="customer-management"
                  element={
                    <Layout>
                      <CustomerManagment />
                    </Layout>
                  }
                />
                {/* صفحه باشگاه مشتریان    */}
                <Route
                  path="customer-club"
                  element={
                    <Layout>
                      <ClubPage />
                    </Layout>
                  }
                />
                <Route
                  path="financial-department"
                  element={
                    <Layout>
                      <FinancialDepartment2 type={1} />
                    </Layout>
                  }
                />
                <Route
                  path="transactions"
                  element={
                    <Layout>
                      <Transactions />
                    </Layout>
                  }
                />
                {/*  صفحه کسب و کار   */}
                <Route
                  path="bussiness"
                  element={
                    <Layout>
                      <BussinessPage />
                    </Layout>
                  }
                />
                {/* لیست کیف پول */}
                <Route
                  path="wallets"
                  element={
                    <Layout>
                      <WalletList />
                    </Layout>
                  }
                />
                <Route
                  path="orders"
                  element={
                    <Layout>
                      <OrdersSuperAdmin />
                    </Layout>
                  }
                />
                <Route
                  path="financial-management"
                  element={
                    <Layout>
                      <FinancialDepartment3 />
                    </Layout>
                  }
                />

                {/* صفحه آپلود فایل اکسل برای افزودن ریکورد در دیتابیس */}
                <Route path="upload-excel" element={<UploadPage />} />
                {/*دکمه دسترسی سوپر ادمین به صفحات فروشگاهی */}
                <Route
                  path="permission-button"
                  element={<PermissionButton />}
                />
              </Route>
              {/*صفحات ادمین */}
              <Route
                path="admin-panel/:supplier_id"
                element={<ProtectedRoute />}
              >
                {/*صفحه پنل ادمین */}
                <Route
                  index
                  element={
                    <Layout>
                      <AdminPanel />
                    </Layout>
                  }
                />
                {/*صفحه امور مالی */}
                {/* <Route
                  path="financial-department"
                  element={
                    <Layout>
                      <FinancialDepartment />
                    </Layout>
                  }
                /> */}
              </Route>
              {/*  صفحات کاربر   */}
              <Route path="customer-panel" element={<ProtectedRoute />}>
                {/* customer panel */}
                <Route
                  index
                  element={
                    <Layout>
                      {/* <CustomerPanel /> */}
                      {/* <SpecialBaskets /> */}
                      <ProfileBase />
                    </Layout>
                  }
                />
                {/*  صفحه پروفایل   */}
                {/* <Route
                  path="profile"
                  element={
                    <Layout>
                      <ProfilePage />
                    </Layout>
                  }
                /> */}

                {/*صفحه امور مالی */}
                {/* <Route
                  path="financial-department"
                  element={
                    <Layout>
                      <FinancialDepartment type={0} />
                    </Layout>
                  }
                /> */}
              </Route>
              {/*  فروشگاه   */}
              <Route
                path="shop"
                element={
                  <Layout>
                    <ShopPage />
                  </Layout>
                }
              />
              {/*صفحه تامین کننده */}
              <Route
                path="supplier/:supplier_id"
                element={
                  <Layout>
                    <Supplier />
                  </Layout>
                }
              />
              {/* landing */}
              <Route
                index
                element={
                  <Layout>
                    <Landing />
                    {/* <AdminPanel /> */}
                  </Layout>
                }
              />
              {/*صفحه امور مالی */}
              {/* <Route
                path="financial-department"
                element={
                  <Layout>
                    <FinancialDepartment type={1} />
                  </Layout>
                }
              /> */}

              {/*  لاین ها */}
              <Route
                path="all-lines/:lineId"
                element={
                  <Layout>
                    <Supplier type="line" />
                    {/* <SubLinePage /> */}
                  </Layout>
                }
              />
              <Route
                path="listLines"
                element={
                  <Layout>
                    <ParentListLines></ParentListLines>
                  </Layout>
                }
              />
              {/* <Route path="*" element={<Navigate to="/" />} /> */}
            </Routes>
          </CustomerClubContextProvider>
        </UserContextProvider>
      </SupplierContextProvider>
    </>
  );
}

function ProtectedRoute({ children }) {
  const { userInfo, isLogged, isChecked } = useContext(AuthenticationContext);
  const route = useLocation();
  const params = useParams();

  if (!isChecked) {
    return <Loader />;
  }

  let flag = false;
  if (route.pathname.includes("/customer-panel") && isLogged) {
    flag = true;
  } else {
    if (
      route.pathname.includes("/admin-panel") &&
      userInfo.access_level.findIndex((value) =>
        [
          ACCESS_LEVEL.a_define_basket,
          ACCESS_LEVEL.a_define_product,
          ACCESS_LEVEL.a_main_management,
          ACCESS_LEVEL.a_orders_management,
          ACCESS_LEVEL.a_sent_orders_management,
        ].includes(value.code)
      ) !== -1 &&
      userInfo.supplier_list.includes(params.supplier_id)
    ) {
      flag = true;
    }
    if (
      userInfo.access_level.findIndex((value) =>
        [
          ACCESS_LEVEL.sa_options_management,
          ACCESS_LEVEL.sa_orders_management,
          ACCESS_LEVEL.sa_product_management,
          ACCESS_LEVEL.sa_user_management,
        ].includes(value.code)
      ) !== -1
    ) {
      flag = true;
    }
  }

  if (flag === true) {
    return children ? children : <Outlet />;
  }
  return <Navigate to="/" replace />;
}
